/* eslint-disable @typescript-eslint/no-explicit-any */

import { Type } from '@angular/core';

//@index('./*.ts', f => `export * from '${f.path}';`)
export * from './BooleanOrNullOrUndefined';
export * from './DateOrNullOrUndefined';
export * from './debounce.utils';
export * from './formatDate';
export * from './NumberOrNullOrUndefined';
export * from './StringOrNullOrUndefined';
export * from './api-error.util';
export * from './client-field-help-texts';
export * from './permissions.utils';
//@endindex

export function compareObjects(
  obj1: Record<string, unknown>,
  obj2: Record<string, unknown>
): Record<string, { obj1: unknown; obj2: unknown }> {
  const differences: Record<string, { obj1: unknown; obj2: unknown }> = {};
  function compare(
    left: Record<string, unknown>,
    right: Record<string, unknown>,
    prefix = ''
  ) {
    for (const key in left) {
      if (Object.prototype.hasOwnProperty.call(left, key)) {
        const value1 = left[key];
        const value2 = right[key];
        if (
          typeof value1 === 'object' &&
          value1 !== null &&
          typeof value2 === 'object' &&
          value2 !== null
        ) {
          compare(
            value1 as Record<string, unknown>,
            value2 as Record<string, unknown>,
            `${prefix}${key}.`
          );
        } else if (value1 !== value2) {
          differences[`${prefix}${key}`] = { obj1: value1, obj2: value2 };
        }
      }
    }
    for (const key in right) {
      if (
        Object.prototype.hasOwnProperty.call(right, key) &&
        !Object.prototype.hasOwnProperty.call(left, key)
      ) {
        if (right[key] !== undefined)
          differences[`${prefix}${key}`] = {
            obj1: undefined,
            obj2: right[key],
          };
      }
    }
  }
  compare(obj1, obj2);
  return differences;
}
export function logTable(a: Record<string, unknown>, b: Record<string, unknown>) {
  console.table(compareObjects(a, b));
}

export function ArrayOrNullOrUndefined<T>(value: T[]): T[] | null | undefined {
  return value === undefined
    ? undefined
    : value === null
    ? null
    : (value as any) === 'null'
    ? null
    : (value as any) === 'undefined'
    ? undefined
    : (value as any) === '[]'
    ? []
    : typeof (value as any) === 'string'
    ? JSON.parse(value as any)
    : (value as T[]);
}
export function ForceArray<T>(value: T[]): T[] {
  return ArrayOrNullOrUndefined(value) ?? [];
}

export function ForceMap<T>(value: T[], constructor: Type<T>): T[] {
  return ForceArray<T>(value).map((item) => new constructor(item));
}

export function TypeOrNullOrUndefined<T>(
  value: T,
  constructor: Type<T>
): T | null | undefined {
  return value === undefined || value === 'undefined'
    ? undefined
    : value === null || value === 'null'
    ? null
    : new constructor(value);
}
